<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :description="description"
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
            :class="['form-group-radio', {'placeholder-label': label === false }, { 'm-0': !label }, { 'mt-1': centerInput }]"
        >
            <label
                v-if="label"
                :for="id"
                :class="{ 'pb-0': buttons }"
            >
                {{ label + (rules && rules.required ? ' *' : '') }}
            </label>

            <template v-if="tooltipText">
                <rkm-tooltip
                    :placement="tooltipPosition"
                    :target="uniqueId('FormRadioGroupTooltip')"
                >
                    {{ tooltipText }}
                </rkm-tooltip>

                <rkm-icon
                    :id="uniqueId('FormRadioGroupTooltip')"
                    class="ml-1"
                    icon="info-circle"
                />
            </template>

            <div :class="{ inline, 'ml-2': inline }">
                <b-form-radio-group
                    :class="{ 'form-group-radio-button-disabled': buttons && disabled }"
                    :button-variant="buttonColor"
                    :buttons="buttons"
                    :checked="checked"
                    :disabled="disabled"
                    :name="name"
                    :options="options"
                    :required="required"
                    :size="size"
                    :stacked="stacked"
                    :state="rules ? (validated ? valid : null) : null"
                    :text-field="textField"
                    :value-field="valueField"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                    <slot />
                </b-form-radio-group>
            </div>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { BFormRadioGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';

export default {
    components: { BFormRadioGroup, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        tooltipPosition() {
            if(this.tooltipTop)
                return 'top'
            else if(this.tooltipRight)
                return 'right'
            else if(this.tooltipBottom)
                return 'bottom'
            else if(this.tooltipLeft)
                return 'left'

            return ''
        },
        tooltipText() {
            return this.tooltipTop
                || this.tooltipRight
                || this.tooltipBottom
                || this.tooltipLeft
        },
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        },
    },
    model: { prop: 'checked', event: 'input' },
    props: {
        buttonColor: { type: String },
        buttons: { type: Boolean, default: false },
        checked: { type: [Number, String, Boolean], default: null },
        description: { type: String },
        disabled: { type: Boolean },
        label: { type: [String, Boolean], default: '' },
        inline: { type: Boolean, default: false },
        large: { type: Boolean, default: false },
        name: { type: String },
        options: { type: [Array, Object], default: () => [] },
        required: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        stacked: { type: Boolean },
        textField: { type: String, default: 'text' },
        tooltipBottom: { type: String },
        tooltipLeft: { type: String },
        tooltipRight: { type: String },
        tooltipTop: { type: String },
        validationMode: { type: String, default: 'lazy' },
        validations: { type: Object, default: null },
        valueField: { type: String, default: 'value' },
        centerInput: { type: Boolean, default: false }
    }
}
</script>

<style scoped>
.inline {
    display: inline;
}
</style>